import { cn, focusRing, UiLink } from "@rhema/ui";
import { progressOf, useImports } from "./ImportProvider";

/**
 * A slim line that shows an import is running while the person is elsewhere in the app. It links
 * back to the import screen.
 */
export function ImportBanner({ variant }: { variant: "phone" | "desktop" }) {
  const { items, halted } = useImports();
  const running = items.find((i) => i.status === "running");
  const waiting = items.filter((i) => i.status === "queued").length;
  if (!running && !halted) return null;
  const percent = running ? Math.round(progressOf(running) * 100) : 0;
  const text = halted
    ? "Import stopped. Your storage is full."
    : `Importing ${running!.title}, ${percent}%${waiting ? `. ${waiting} more waiting` : ""}`;
  return (
    <UiLink
      href="/import"
      className={cn(
        "flex flex-col gap-1 bg-surface px-4 py-2 text-[13px] font-semibold text-ink no-underline",
        variant === "desktop"
          ? "fixed right-4 bottom-4 z-30 w-[280px] rounded-card border border-line shadow-menu"
          : "border-t border-line",
        halted && "text-scarlet",
        focusRing,
      )}
    >
      <span className="truncate">{text}</span>
      {running && (
        <span aria-hidden="true" className="block h-1 overflow-hidden rounded-full bg-surface-header">
          <span className="block h-1 rounded-full bg-blue" style={{ width: `${percent}%` }} />
        </span>
      )}
    </UiLink>
  );
}
